import React from 'react';
import PropTypes from 'prop-types';

// Style
import useStyles from '../../../../assets/styles/components/cards/landSearchProgramCard/landSearchProgramCardBodyStyle';

// Material components
import { Box } from '@material-ui/core';

const LandSearchProgramCardBody = ({backgroundImage, children}) => {
    const classes = useStyles({backgroundImage});

    return (
        <Box className={classes.rootLandSearchProgramCardBody}>
            {children}
        </Box>
    );
};

LandSearchProgramCardBody.propTypes = {
    backgroundImage: PropTypes.string.isRequired,
};

export default LandSearchProgramCardBody;